import { GET_DATA, SET_DATA, RESET_DATA } from 'modules/Countries/types'

export const actionGetData = (props) => ({
  type: GET_DATA,
  payload: props,
})

export const actionSetData = (props) => ({
  type: SET_DATA,
  payload: props,
})

export const actionResetData = () => ({
  type: RESET_DATA,
})
